(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/mybets/mybets.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/mybets/mybets.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.MyBets = Marionette.View.extend({
    template: function(data) {
      return svs.bingo.templates.bingoclient(data);
    },

    initialize: function(options) {
      this.gameId = options.wagerId;
    },

    onAttach: function() {
      svs.bingo.nyxChannel.request('initBingoClient', this.options);
    }
  });
})(Backbone, _, svs);


 })(window);